import React, { useState } from 'react';
import PropTypes from 'prop-types';

import config from 'config';
import Icon from 'shared/components/Icon';
import { AppToastsPlace, ModalsPlace, WebviewListeners } from 'modules/messageSystem/components';

import { Header, Footer, AccessibilityShortcuts } from 'modules/common/components';

import theme from './AppLayout.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  hideHeader: PropTypes.bool.isRequired,
  hideFooter: PropTypes.bool.isRequired,
  isReactNative: PropTypes.bool.isRequired,
};

const defaultProps = {};

const ThemePicker = () => {
  const [themePickerShown, toggleThemePicker] = useState(true);
  const [colors, setColor] = useState({
    '--primary-medium': config.primary_medium_color,
  });

  const changeColor = e => {
    setColor({ [e.target.name]: e.target.value });
    root.style.setProperty(e.target.name, e.target.value);
  };

  return (
    themePickerShown && (
      <div style={{ position: 'absolute', left: 0, bottom: 42, zIndex: 1, background: 'white' }}>
        { Object.entries(colors).map(([name, color]) => (
          <label>
            { name }: { color }
            <input type="color" name={ name } defaultValue={ color } onChange={ changeColor } />
          </label>
        )) }

        <Icon name="circle-x-fill" onClick={ () => toggleThemePicker(false) } />
      </div>
    )
  );
};

const AppLayout = ({ children, hideHeader, hideFooter, isReactNative }) => (
  <div className={ theme.root } id="rootPage">
    <AppToastsPlace containerClassName={ theme.toastsPlaceContainer } />
    <ModalsPlace />
    <AccessibilityShortcuts />
    { isReactNative && <WebviewListeners /> }
    {/* { process.env.NODE_ENV !== 'production' && <ThemePicker /> } */}

    <div className={ theme.contentWrapper }>
      <If condition={ !hideHeader && !isReactNative }>
        <Header />
      </If>
      <main className={ theme.content }>
        { children }
      </main>
      <If condition={ !hideFooter && !isReactNative }>
        <Footer />
      </If>
    </div>
  </div>
);

AppLayout.propTypes = propTypes;
AppLayout.defaultProps = defaultProps;

export default AppLayout;
